import c from './_dropZone.module.scss';

import clsx from 'clsx';
import i18n from 'i18n-react';
import { useDropzone } from 'react-dropzone';

interface DropZoneProps {
  onFilesSelected: (_files: File[]) => void;
  className?: string;
  disabled?: boolean;
}

export default function DropZone({ onFilesSelected, className, disabled }: DropZoneProps) {
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'application/pdf': [],
    },
    multiple: false,
    disabled,
    onDrop: (acceptedFiles) => {
      onFilesSelected(acceptedFiles);
    },
  });

  return (
    <section className={clsx(c.dropzoneWrapper, className)}>
      <div {...getRootProps({ className: clsx(c.dropzone, disabled && c.disabled) })}>
        <input {...getInputProps()} />
        <p>{i18n.translate('rewards.bookingForm.dragAndDrop')}</p>
        <em>{i18n.translate('rewards.bookingForm.acceptedFiles')}</em>
      </div>
    </section>
  );
}
